











import { Component } from "vue-property-decorator"
import { DataTableHeader } from "vuetify"
import VueTrans from "@/mixins/VueTrans.vue"
import { mixins } from "vue-class-component"
import VuePagination from "@/mixins/VuePagination.vue"
import ConfirmDeletionDialog from "@/components/elements/dialog/ConfirmDeletionDialog.vue"
import FaoCountryForm from "@/components/templateSubmission/surveyDataManagement/beneficiaryDataSheet/harmonizationSettings/ham/FaoCountryForm.vue"
import CopyUtils from "@/services/utils/CopyUtils"
import FaoCountryModule from "@/store/modules/fao/FaoCountryModule"
import { FaoCountry } from "@/model/interfaces/fao/faoCountry"
import FaoCountryIso3Form from "@/components/dashboard/dataAnalysis/globalHarmonizationSettings/form/FaoCountryIso3Form.vue"

@Component({
  components: { FaoCountryIso3Form, FaoCountryForm, ConfirmDeletionDialog }
})
export default class FaoCountryTable extends mixins(VueTrans, VuePagination) {
  transKey = "dashboard.dataAnalysis.globalHarmonisationSettings.table.faoCountry."

  async mounted(): Promise<void> {
    await FaoCountryModule.getAll()
  }

  get loading(): boolean {
    return FaoCountryModule.loading
  }

  get headers(): DataTableHeader[] {
    return [
      { text: this.t("headers.faoCountryName"), value: "name", sortable: false },
      { text: this.t("headers.countryIso3"), value: "iso3", sortable: false },
      { text: this.t("headers.actions"), value: "actions", sortable: false }
    ] as DataTableHeader[]
  }

  get items(): FaoCountry[] {
    return FaoCountryModule.faoCountries
  }

  get itemCount(): number {
    return FaoCountryModule.pagination.itemCount
  }

  edit(faoCountry: FaoCountry): void {
    FaoCountryModule.setCurrent((CopyUtils.create((faoCountry as unknown) as Record<string, unknown>) as unknown) as FaoCountry)
    FaoCountryModule.setDialogForm(true)
  }
}
